/* eslint-disable */

import 'plyr-react/plyr.css'
import useVideoPlayer from '@/hooks/client/Booking/useVideoPlayer'
import useTranslation from 'next-translate/useTranslation'

const VideoPlayer = ({ data }: { data: any }) => {
  const { lang } = useTranslation()
  const { media, MediaSrc } = useVideoPlayer({ data })
  return (
    <div
      className="flex justify-center mb-6 mt-8"
      style={{ direction: lang === 'ar' ? 'rtl' : 'ltr' }}
    >
      <div className="w-[640px]">
        {media.map((el, index: number) => (
          <div key={el.id} className="mb-6 border-b border-neutral-400">
            <p className="text-lg font-bold">{index + 1 + '. ' + el.title}</p>
            <div className="mb-[90px] mt-2">{MediaSrc(el)}</div>
          </div>
        ))}
      </div>
    </div>
  )
}
export default VideoPlayer
